<template>
  <div class="fixed-plugin no-print" v-click-outside="closeDropDown">
    <div class="dropdown show-dropdown" :class="{ show: isOpen }">
      <a data-toggle="dropdown" class="settings-icon">
        <i class="fa fa-cog fa-2x" @click="toggleDropDown"> </i>
      </a>
      <ul class="dropdown-menu" :class="{ show: isOpen }">
        <li v-if="withSidebar" class="header-title">Sidebar Background</li>
        <li v-if="withSidebar" class="adjustments-line">
          <a class="switch-trigger background-color">
            <div class="badge-colors text-center">
              <span
                v-for="item in sidebarColors"
                :key="item.color"
                class="badge filter"
                :class="[`badge-${item.color}`, { active: item.active }]"
                :data-color="item.color"
                @click="changeSidebarBackground(item);"
              ></span>
            </div>
            <div class="clearfix"></div>
          </a>
        </li>

        <li v-if="withSidebar" class="header-title">Sidebar Mini</li>
        <li v-if="withSidebar" class="adjustments-line">
          <div class="togglebutton switch-sidebar-mini">
            <span class="label-switch">OFF</span>
            <base-switch
              v-model="sidebarMini"
              @input="minimizeSidebar"
            ></base-switch>
            <span class="label-switch label-right">ON</span>
          </div>
        </li>
<!--        <li class="adjustments-line  mb-4">-->
<!--          <div class="togglebutton switch-change-color mt-3">-->
<!--            <span class="label-switch">LIGHT MODE</span>-->
<!--            <base-switch :value="darkMode" @input="toggleMode"></base-switch>-->
<!--            <span class="label-switch label-right">DARK MODE</span>-->
<!--          </div>-->
<!--        </li>-->

        <li class="button-container">
          <a
            href="https://demos.creative-tim.com/vue-black-dashboard-pro/documentation"
            target="_blank"
            rel="noopener"
            class="btn btn-default btn-block btn-round"
          >
            Documentation
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {BaseSwitch} from 'src/components';

export default {
  name: 'sidebar-share',
  components: {
    BaseSwitch
  },
  props: {
    backgroundColor: String,
    withSidebar: Boolean,
  },
  computed: {
    darkMode() {
      return this.$store.state.app.darkMode
    }
  },
  data() {
    return {
      sidebarMini: true,
      isOpen: false,
      sidebarColors: [
        {color: 'primary', active: false, value: 'primary'},
        {color: 'vue', active: true, value: 'vue'},
        {color: 'info', active: false, value: 'blue'},
        {color: 'success', active: false, value: 'green'},
        {color: 'warning', active: false, value: 'orange'},
        {color: 'danger', active: false, value: 'red'}
      ]
    };
  },
  methods: {
    toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown() {
      this.isOpen = false;
    },
    toggleList(list, itemToActivate) {
      list.forEach(listItem => {
        listItem.active = false;
      });
      itemToActivate.active = true;
    },
    changeSidebarBackground(item) {
      this.$emit('update:backgroundColor', item.value);
      this.toggleList(this.sidebarColors, item);
    },
    toggleMode(type) {
      this.$store.dispatch('SetDarkMode', type)
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    }
  }
};
</script>
<style scoped lang="scss">
@import '~@/assets/sass/dashboard/custom/variables';

.settings-icon {
  cursor: pointer;
}

.badge-vue {
  background-color: $vue;
}
</style>
